import type { $Enums } from '@prisma/client';
import { getStatusLabel } from '../../../status-labels';
import { definePolicy, type Policy } from '../kernel';
import { deny } from '../types';
import {
  decideHostCharge,
  HOST_CHARGE_FIELDS,
  HOST_CHARGE_OPS,
  type HostChargeFacts,
  type HostChargeField,
  type HostChargeOp,
} from './orderChargeBillLock';

/** The charges window today: every status but CLOSED (`LotExpensesSection.tsx` `lot.status !== 'CLOSED'`). */
export const LOT_CHARGE_EDITABLE_STATUSES: readonly $Enums.LotStatus[] = [
  'DRAFT',
  'MID_RECEIVING',
  'OPEN',
  'MID_PRODUCTION_RUN',
  'LOCKED',
];

export type LotExpenseFacts = HostChargeFacts<$Enums.LotStatus>;

const statusLock = (status: LotExpenseFacts['hostStatus']) =>
  deny('LOT_EXPENSE_CHARGES_LOCKED', `Charges are locked once the lot is ${getStatusLabel(status)}.`);

/** Lot charges: the shared host charge rule over this host's window (`decideHostCharge`). */
export const lotExpensePolicy: Policy<LotExpenseFacts, HostChargeField, HostChargeOp> = definePolicy<
  LotExpenseFacts,
  HostChargeField,
  HostChargeOp
>({
  kind: 'lot charge',
  fields: HOST_CHARGE_FIELDS,
  ops: HOST_CHARGE_OPS,
  requires: {},
  entity: (facts, action) =>
    decideHostCharge(
      { editableStatuses: LOT_CHARGE_EDITABLE_STATUSES, statusLock: statusLock(facts.hostStatus) },
      facts,
      action
    ),
});
